import {Axios} from '../axios/axios'
//任务列表
export const getOrderList = (e) => {
  return Axios({
    url:"/adminapi/getOrderList",
    method:'POST',
    data:e
  })
}
//订单详情  /adminapi/getOrderDetail
export const getOrderDetail = (e) => {
  return Axios({
    url:"/adminapi/getOrderDetail",
    method:'POST',
    data:e
  })
}
//公共接口 adminapi/getPublicData
export const getAllPublicData = (e) => {
  return Axios({
    url:"/adminapi/getPublicData",
    method:'POST',
    data:e
  })
}
//adminapi/getRefundRecords 获取退款详情
export const getRefundRecordsData = (e) => {
  return Axios({
    url:"/adminapi/getRefundRecords",
    method:'POST',
    data:e
  })
}
//订单备注 adminapi/addNote
export const addNote = (e) => {
  return Axios({
    url:"/adminapi/addNote",
    method:'POST',
    data:e
  })
}
//取消订单 adminapi/cancelOrder
export const cancelOrder = (e) => {
  return Axios({
    url:"/adminapi/cancelOrder",
    method:'POST',
    data:e
  })
}
//退款 adminapi/refund
export const refundHandle = (e) => {
  return Axios({
    url:"/adminapi/refund",
    method:'POST',
    data:e
  })
}
